import React from "react";
import { StorageType } from "../../../../api/entities/shard-repository";
import IOption from "../../../shared-ui/common/option";
import { FiltersBar } from "../../../shared-ui/filters-bar/filters-bar";
import SearchInput from "../../../shared-ui/input/search-input/search-input";
import { StorageTypeFilter } from "../storage-type-filter";
import styles from "./storage-node-list-filters.module.scss";

export const defaultFilters: IShardRepositoryFilters = {
  q: null,
  storageTypeFilter: null
}

export enum StorageNodeListFilter {
  Search = "search",
  StorageType = "storage-type"
}

export interface IShardRepositoryFilters {
  q: string;
  storageTypeFilter: IOption<StorageType>;
}

export interface IShardRepositoryListFiltersProps {
  title?: string;
  visibleFilters?: StorageNodeListFilter[];
  filterSearchParams: IShardRepositoryFilters;
  onFiltersChange: (filters: Partial<IShardRepositoryFilters>) => void;
}

export function StorageNodeListFilters(props: IShardRepositoryListFiltersProps) {
  const filters = props.visibleFilters || [StorageNodeListFilter.Search, StorageNodeListFilter.StorageType];

  return (
    <FiltersBar>
      {filters.includes(StorageNodeListFilter.Search) && (
        <SearchInput
          className={styles.search}
          value={props.filterSearchParams.q}
          onChange={q => props.onFiltersChange({ q })}
        />
      )}
      {filters.includes(StorageNodeListFilter.StorageType) && (
        <StorageTypeFilter
          className={styles.type}
          value={props.filterSearchParams.storageTypeFilter}
          onChange={(storageTypeFilter) => props.onFiltersChange({ storageTypeFilter })}
          autoWidth
        />
      )}
    </FiltersBar>
  );
}
